import styled from 'styled-components'
import { css, radiuses } from 'styles'

const sizes = {
  medium: css`
    padding: 0.6rem 2rem;
    font-size: 1.2rem;
  `,
  large: css`
    padding: 0.6rem 2.6rem;
    font-size: 1.8rem;
  `,
}

const StyledButton = styled.button`
  box-sizing: border-box;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  appearance: none;
  display: inline-block;

  ${({ fill, color, size, theme: { colors } }) => {
    const filled = fill == 'filled'

    return css`
      background-color: ${filled ? colors[color] : fill};
      color: ${filled ? colors.mainInverted : colors.textMain};
      border: 0.1rem solid ${filled ? 'transparent' : ''};
      border-radius: ${radiuses[size == 'large' ? 'medium' : 'small']};
    `
  }}

  ${p => sizes[p.size]};
  ${p => p.disabled && 'opacity: 0.4;'};
  ${p => p.color == 'cta' && 'font-weight: 700;'};

  &:active,
  &:focus {
    outline: 0;
  }
`

export default StyledButton
